/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Search_Warehouse_PlaceholderInputs */

const en_cargos_search_warehouse_placeholder = /** @type {(inputs: Cargos_Search_Warehouse_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search warehouse...`)
};

const es_cargos_search_warehouse_placeholder = /** @type {(inputs: Cargos_Search_Warehouse_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar almacen...`)
};

/**
* | output |
* | --- |
* | "Search warehouse..." |
*
* @param {Cargos_Search_Warehouse_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_search_warehouse_placeholder = /** @type {((inputs?: Cargos_Search_Warehouse_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Search_Warehouse_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_search_warehouse_placeholder(inputs)
	return es_cargos_search_warehouse_placeholder(inputs)
});